(()=>{
const format=cents=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:'EUR'}).format(cents/100);
function context(box){
 const lido=box.closest('[data-sf-preorders]');
 const form=box.dataset.formId?document.getElementById(box.dataset.formId):box.closest('form');
 if(!form)return null;
 let variant,price=Number(box.dataset.price)||0;
 if(lido){const products=JSON.parse(lido.querySelector('[data-products]').textContent);const current=products[Number(lido.querySelector('[data-model-select]').value)];variant=current?.variants.find(v=>String(v.id)===String(form.elements.id.value));price=variant?.price_cents||current?.variants[0]?.price_cents||price;}
 else{const variants=JSON.parse(box.querySelector('[data-review-variants]').textContent||'[]');variant=variants.find(v=>String(v.id)===String(form.elements.id.value));price=variant?.price||price;}
 const quantity=form.elements.quantity||document.querySelector('input.quantity__input[form="'+box.dataset.formId+'"]');
 return{form,lido,variant,amount:price*Number(quantity?.value||1),full:box.querySelector('input:checked')?.value==='full'};
}
function refresh(box){
 const c=context(box);if(!c)return;
 const deferred=box.querySelector('input[value="dispatch"]');
 deferred.disabled=!!c.variant&&!c.variant.plan;
 if(deferred.disabled&&deferred.checked){box.querySelector('input[value="full"]').checked=true;c.full=true;}
 let message=box.querySelector('[data-payment-error]');
 if(!message){message=document.createElement('p');message.dataset.paymentError='';message.setAttribute('role','status');message.className='sf-dispatch-terms';box.append(message);}
 const notice=deferred.disabled?box.dataset.unavailable:'';if(message.textContent!==notice)message.textContent=notice;
 for(const [key,value] of [['today',c.full?c.amount:0],['later',c.full?0:c.amount]]){const el=box.querySelector('[data-due-'+key+']');const text=format(value);if(el.textContent!==text)el.textContent=text;}
 box.querySelector('[data-dispatch-terms]').hidden=c.full;box.querySelector('[data-full-terms]').hidden=!c.full;
 let input=c.form.elements.selling_plan;
 if(!input){input=document.createElement('input');input.type='hidden';input.name='selling_plan';c.form.append(input);}
 input.value=c.full?'':c.variant?.plan||'';input.disabled=c.full;
}
function init(){document.querySelectorAll('sf-dispatch-options').forEach(refresh);}
document.addEventListener('submit',e=>{
 const form=e.target;if(!form.matches('form[action*="/cart/add"]'))return;
 const box=form.querySelector('sf-dispatch-options')||document.querySelector('sf-dispatch-options[data-form-id="'+form.id+'"]');if(!box)return;
 refresh(box);const c=context(box);
 if(c.variant&&!c.full&&!c.variant.plan){e.preventDefault();e.stopImmediatePropagation();box.querySelector('[data-payment-error]').textContent=box.dataset.unavailable;}
},true);
document.addEventListener('change',()=>queueMicrotask(init));document.addEventListener('input',()=>queueMicrotask(init));document.addEventListener('click',()=>requestAnimationFrame(init));document.addEventListener('shopify:section:load',init);
new MutationObserver(init).observe(document.getElementById('MainContent'),{childList:true,subtree:true});init();
})();


// Materials precede payment on phones; the desktop editorial remains untouched.
(() => {
  const style = document.createElement('style');
  style.textContent = `
.sf-mobile-materials-first{display:none}
@media(max-width:749px){ #MainContent .product__info-container h1{letter-spacing:.6px} #MainContent .product__info-container .price{font-size:18px;line-height:27px} #MainContent .sf-mobile-materials-first .materials-title{font-size:20px;line-height:27px;font-weight:300;letter-spacing:-.4px}
.sf-mobile-materials-source{display:none!important}
.sf-mobile-materials-first{display:block;margin:28px 0 24px;padding-top:24px;border-top:1px solid #e4e0d9}
.sf-mobile-materials-first .materials-title{font-size:22px;line-height:1.35;margin:0 0 8px;font-weight:400}
.sf-mobile-materials-first .sf-materials-intro{font-size:13px;line-height:1.7;color:#67635d;margin:0 0 22px}
.sf-mobile-materials-first .material-row{margin:0;padding:17px 0;border-bottom:1px solid #e9e6e0}
.sf-mobile-materials-first .material-row strong{display:block;font-size:14px;font-weight:400!important;line-height:1.5;letter-spacing:.015em}
.sf-mobile-materials-first .material-row p{font-size:12.5px;line-height:1.8;color:#625f59;margin:6px 0 0}
.sf-mobile-materials-first .material-row:last-child{border-bottom:0}
}`;
  document.head.append(style);
  function initMaterials() {
    const main = document.getElementById('MainContent');
    if (!main) return;
    main.querySelectorAll('sf-dispatch-options').forEach(payment => {
      const root = payment.closest('[data-sf-preorders]') || main;
      const source = root.querySelector('.sf-materials-editorial');
      if (!source || source.dataset.mobileMaterialsReady) return;
      source.dataset.mobileMaterialsReady = 'true';
      const copy = document.createElement('div');
      copy.className = 'materials product__description rte sf-mobile-materials-first';
      function sync() {
        copy.innerHTML = source.innerHTML;
        copy.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
        copy.querySelectorAll('.material,.leather-title').forEach(el => el.classList.remove('material','leather-title'));
      }
      sync();
      payment.before(copy);
      source.classList.add('sf-mobile-materials-source');
      new MutationObserver(sync).observe(source, {childList:true,subtree:true,characterData:true});
    });
  }
  document.addEventListener('shopify:section:load', initMaterials);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initMaterials);
  else initMaterials();
})();
